<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息"
      @leftClick="$router.push({path: '/corporate/legal',query: {type: $route.query.type}})"
    >
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <cube-form
        class="form-custom"
        :model="Model"
        :options="options"
        @submit="$_handlerSubmit">
        <cube-form-group legend="经办人信息">
          <cube-form-item :field="Fields[0]"></cube-form-item>
          <cube-form-item :field="Fields[1]"></cube-form-item>
          <cube-form-item :field="Fields[2]"></cube-form-item>
          <cube-form-item :field="Fields[3]">
            <div @click.stop="$_handleShowManagersDocumentsValidityPicker" style="text-align:right;">
              <span
                :style="{'color': Model.managersDocumentsValidity ? '#666' : '#ccc'}">
                {{Model.managersDocumentsValidity || '请选择证件有效期'}}
              </span>
              <i class="cubeic-arrow" style="color: #666"></i>
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[4]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="">
          <cube-form-item :field="Fields[5]"></cube-form-item>
          <cube-form-item :field="Fields[6]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" >
          <cube-form-item :field="Fields[7]"></cube-form-item>
          <cube-form-item :field="Fields[8]"></cube-form-item>
          <cube-form-item :field="Fields[9]"></cube-form-item>
          <cube-form-item :field="Fields[10]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" >
          <cube-form-item :field="Fields[11]"></cube-form-item>
          <cube-form-item :field="Fields[12]"></cube-form-item>
          <cube-form-item :field="Fields[13]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" class="submit-btn">
          <cube-button type="submit">下一步</cube-button>
        </cube-form-group>
      </cube-form>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mixin from './config/addManagerConfig';
import cmixin from '../../commonConfig';

export default {
  mixins: [mixin, cmixin],
  computed: {
    ...mapGetters(['managerInfo', 'au', 'corporateInfo']),
  },
  created() {
  },
  mounted() {
    setTimeout(() => {
      this.$bridge.callHandler('getBaseInfo', { msg: '获取投资者基本信息' }, (data) => {
        const obj = JSON.parse(data);
        console.log('新增', obj);
        this.$_handlerInit(obj.baseInfo);
        this.$_handlerInitData();
      });
    }, 300);
  },
  methods: {
    $_handlerInitData() {
      Object.keys(this.Model).forEach((key) => {
        if (this.corporateInfo[key]) {
          this.Model[key] = this.corporateInfo[key];
        }
      });
    },
    $_handlerInit(data) {
      const obj = JSON.parse(data);
      // Object.keys(this.Model).forEach((key) => {
      //   this.Model[key] = obj[key];
      // });
      Object.keys(this.Model).forEach((key) => {
        if (obj[key]) {
          this.Model[key] = obj[key];
        }
      });
      // this.Model.managersName = obj.managersName;
      // this.Model.managersDocumentsType = obj.managersDocumentsType;
      // this.Model.managersIdCardNo = obj.managersIdCardNo;
      // this.Model.managersMobile = obj.managersMobile;

      // 是否 法人信息为经办人
      const isManager = obj.managersName === obj.representativeName && obj.managersIdCardNo === obj.representativeIdCardNo;
      if (isManager) {
        // 如果管理人Model里没有数据, 使用上一页保存的数据填充
        [
          ['managersSex', 'representativeSex'],
          ['managersAge', 'representativeAge'],
          ['managersPosition', 'representativePosition'],
          ['managersEmail', 'representativeEmail'],
          ['managersDocumentsValidity', 'representativeDocumentsValidity'],
          ['managersLanline', 'representativeLanline'],
          ['managersMobile', 'representativeMobile'],
          ['managersZip', 'representativeZip'],
          ['managersAddress', 'representativeAddress'],
          ['isManagerValidateForever', 'isManagerValidateForever'],
        ].forEach(([model, corporateInfo]) => {
          if (!this.Model[model]) {
            this.Model[model] = this.corporateInfo[corporateInfo];
          }
        });
      } else {
        this.$_getAgeAndSex(obj.managersIdCardNo);
      }
      if (this.Model.managersDocumentsValidity === '永久有效') {
        this.Model.isManagerValidateForever = true;
      } else {
        this.Model.isManagerValidateForever = false;
      }
    },
    $_handlerSubmit(e) {
      e.preventDefault();
      this.$store.dispatch('changeCorporateInfo', this.Model).then(() => {
        this.$router.push({
          path: '/corporate/questions',
          query: {
            type: this.$route.query.type,
            draftsNo: this.$route.query.draftsNo,
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
